import { useTranslation } from "react-i18next";
import PageWrapper from "../../../components/common/layout/PageWrapper";
import RSearchAcademicRecognition from "../../../components/registers/search/academicRecognition/RSearchAcademicRecognition";

const AcademicRecognitionsRegister = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.academicRecognition")}>
      <RSearchAcademicRecognition />
    </PageWrapper>
  );
};

export default AcademicRecognitionsRegister;
